
    <template>
    <svg viewBox="0 0 14 10" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M13.125 9.375H0.875V1.14457C0.875 0.961476 1.10061 0.87463 1.22338 1.01046L6.69026 7.0593C6.73093 7.1 6.77921 7.13227 6.83236 7.1543C6.88551 7.17632 6.94248 7.18765 7.00001 7.18765C7.05754 7.18765 7.1145 7.17632 7.16765 7.1543C7.2208 7.13227 7.26909 7.1 7.30976 7.0593L12.7766 1.01047C12.8994 0.87463 13.125 0.961477 13.125 1.14457V9.375Z"
    fill="currentColor"
  />
  <path
    d="M11.5091 0.625C11.6823 0.625 11.7736 0.830139 11.6577 0.958832L7.00001 6.13137L2.34227 0.958832C2.22639 0.830139 2.31772 0.625 2.4909 0.625H11.5091Z"
    fill="currentColor"
  />
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'EmailFill',
    }) as DefineComponent
    </script>
    